import service from '@api/config'

// 按条件查询招工列表，带分页
export const assignTaskList = (data) => {
  return service.request({
    url: `/recruit/worker/list`,
    method: 'post',
    data: data
  })
}

// 根据找活id查询找活详情
export const assignTaskDetail = (data) => {
  return service.request({
    url: `/assignTask/detail`,
    method: 'post',
    data: data
  })
}
// 根据找活类型获取对应的项目
export const assignProjects = (data) => {
  return service.request({
    url: `/assignTask/projects`,
    method: 'post',
    data: data
  })
}

// 发送报名邀请
export const assignTaskInvite = (data) => {
  return service.request({
    url: `/assignTask/invite`,
    method: 'post',
    data: data
  })
}

// 是否可以邀请报名
export const isMyPub = (data) => {
  return service.request({
    url: `/assignTask/isMyPub`,
    method: 'post',
    data: data
  })
}

// 获取工种分类
export const selectCategoryList = (data) => {
  return service.request({
    url: `/typeOfWork/selectCategoryList`,
    method: 'post',
    data: data
  })
}

// 根据条件查询工种
export const selectByCondition = (data) => {
  return service.request({
    url: `/typeOfWork/selectByCondition`,
    method: 'post',
    data: data
  })
}

// 发布项目后推荐的找活广告列表
export const afterPubWorkerList = (data) => {
  return service.request({
    url: `/recruit/worker/v4.0/afterPub/list`,
    method: 'post',
    data: data
  })
}

// 根据找活id推荐找活信息列表
export const listRecommend = (data) => {
  return service.request({
    url: `/recruit/worker/v4.0/recommend/list`,
    method: 'post',
    data: data
  })
}
